import React from 'react';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemText } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  Character,
  Campaign,
} from "@dndModels";
// import { User } from "@models";

// import DandDCharacterUtilities from '../../../utilities/character_utilities';
import { makeStyles } from "@utilities/theme_utilities";

// import LoadingBox from "@components/input/LoadingBox";
// import DandDAPI from '@dndUtilities/system_api';

interface Props { 
  character: Character;
  campaign: Campaign;
}

// const api = DandDAPI.getInstance();

export default function CharacterCampaignInfo({ 
  character, 
  campaign, 
}: Props) {
  // const [loading, setLoading] = useState(false);
  // const [fetched, setFetched] = useState(false);
  // const [players, setPlayers] = useState<User[]>([]);
  
  // const load = useCallback( async () => {
  //   if (api.user) {
  //     const filter = {
  //       "_id*ObjectIDs": [campaign.owner_id, ...campaign.player_ids]
  //     };
  //     const res = await api.getObjects<User>({
  //       data_type: "user", 
  //       filter,
  //       ignore_templates: false
  //     });
  //     setPlayers(res);
  //   }
  //   setLoading(false);
  // }, [api]);

  // useEffect(() => {
  //   if (!fetched) {
  //     setFetched(true);
  //     setLoading(true);
  //     setTimeout(() => {
  //       load();
  //     }, 100);
  //   }
  // }, [fetched]);

  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        textDecoration: "none"
      },
    });
  });
  const { classes, cx } = useStyles();

  const renderCharacters = () => {
    return campaign.characters.filter(o => o.active && !o.is_archived && o._id !== character._id).map(char => {
      const owner = campaign.players.find(o => o._id === char.owner_id);
      return (
        <Grid key={char._id} container spacing={0} direction="row">
          <Grid size={12}>
            <ListItem className="curvedButton">
              <NavLink to={`/character/${char._id}`} target="_blank" rel="noopener noreferrer"
                className={cx(classes.root, "MyButton")}>
                <ListItemText primary={char.name} className="marginLeft" />
              </NavLink>
            </ListItem>
          </Grid>
          { owner && 
            <Grid size={12} className="small_label gray">
              { owner.profile_name }
            </Grid>
          }
        </Grid>
      );
    });
  }
  
  // if (!fetched || loading) {
  //   return (<LoadingBox />);
  // } else {
    return (
      <div style={{ 
        height: "100%",
        overflowX: "hidden"
      }}>
        <Grid container spacing={0} direction="row">
          <Grid size={12}>
            <ListItem className="curvedButton">
              <NavLink to={`/campaign/${campaign._id}`} target="_blank" 
                className={cx(classes.root, "MyButton")}>
                <ListItemText primary={`Campaign: ${campaign.name}`} className="marginLeft" />
              </NavLink>
            </ListItem>
          </Grid>
          { renderCharacters() }
        </Grid>
      </div>
    );
  // }
}

